import vue from "../main";

const allAvailableColumns = () => {
  return [
    { text: vue.$t("booking.name"), value: "name", sortable: true, selectValue: "name" },
    { text: vue.$t("booking.dateShort"), value: "creation_date", sortable: false, selectValue: "creation_date" },
    { text: vue.$t("booking.numberShort"), value: "reservation_number", sortable: false, selectValue: "reservation_number" },
    { text: vue.$t("booking.flight.route"), value: "", sortable: false, selectValue: "route" },
    { text: vue.$t("booking.ticketNumber"), value: "flightAttributes.ticket_number", sortable: false, selectValue: "ticket_number" },
    { text: vue.$t("booking.passengers"), sortable: false, selectValue: "passengers" },
    { text: vue.$t("global.count"), value: "count", sortable: true, selectValue: "count" },
    { text: vue.$t("booking.discount"), value: "discount", sortable: true, selectValue: "discount" },
    { text: vue.$t("booking.totalNet"), value: "netSummary", sortable: true, selectValue: "netSummary" },
    { text: vue.$t("booking.totalGross"), value: "grossSummary", sortable: true, selectValue: "grossSummary" },
    { text: vue.$t("booking.grossSummaryWithDiscount"), value: "grossSummaryWithDiscount", sortable: true, selectValue: "grossSummaryWithDiscount" },
    {
      text: vue.$t("booking.percentageOfCount"),
      value: "percentageCountAll",
      sortable: true,
      selectValue: "percentageOfCount"
    },
    {
      text: vue.$t("booking.percentageOfSummary"),
      value: "percentageGrossSummaryAll",
      sortable: true,
      selectValue: "percentageOfSummary"
    },
    { text: vue.$t("booking.averageTicketPrice"), value: "averageTicketPrice", sortable: false, selectValue: "averageTicketPrice" },
    { text: vue.$t("booking.airportCharges"), value: "airportCharges", sortable: false, selectValue: "airportCharges" },
    { text: vue.$t("booking.fareBase"), value: "fareBase", sortable: false, selectValue: "fareBase" },
    { text: vue.$t("booking.lowFare"), value: "low_fare", selectValue: "low_fare", sortable: false },
    { text: vue.$t("booking.lostBenefit"), value: "lostBenefit", sortable: false, selectValue: "lostBenefit" },
    { text: vue.$t("booking.lostBenefitPercentage"), value: "lostBenefitPercentage", sortable: false, selectValue: "lostBenefitPercentage" },
    { text: vue.$t("booking.organizationUnit"), value: "organization_unit", selectValue: "organization_unit", sortable: false },
    { text: vue.$t("booking.airlineName"), value: "airline_name", selectValue: "airline_name", sortable: false },
    { text: vue.$t("booking.compartment"), value: "compartment", selectValue: "compartment", sortable: false },
    { text: vue.$t("booking.airlineIATA"), value: "airline_iata", selectValue: "airline_iata", sortable: false },
    { text: vue.$t("booking.airlineICAO"), value: "airline_icao", selectValue: "airline_icao", sortable: false },
    {
      text: vue.$t("booking.percentageOfOrganizationalUnitAmount"),
      value: "percentageOfOrganizationalUnitAmount",
      sortable: false,
      selectValue: "percentageOfOrganizationalUnitAmount"
    },
    {
      text: vue.$t("booking.percentageOfForeignDomesticAmount"),
      value: "percentageOfForeignDomesticAmount",
      sortable: false,
      selectValue: "percentageOfDomesticForeignAmount"
    },
    {
      text: vue.$t("booking.percentageOfOrganizationalUnitCount"),
      value: "percentageOfOrganizationalUnitCount",
      sortable: false,
      selectValue: "percentageOfOrganizationalUnitCount"
    },
    {
      text: vue.$t("booking.percentageOfForeignDomesticCount"),
      value: "percentageOfForeignDomesticCount",
      sortable: false,
      selectValue: "percentageOfDomesticForeignCount"
    },
    {
      text: vue.$t("booking.saleDate"),
      value: "sale_date",
      sortable: false,
      selectValue: "sale_date"
    },
    {
      text: vue.$t("booking.issueDate"),
      value: "issue_date",
      sortable: false,
      selectValue: "issue_date"
    },
    {
      text: vue.$t("booking.invoiceNumber"),
      value: "invoice_number",
      sortable: false,
      selectValue: "invoice_number"
    }
  ];
};

export default allAvailableColumns;
